import { axios } from '@/services/axios';

const getEngine = (engineId) => {
    return axios.get(`/engine/${engineId}`);
};

export default getEngine;
